import { makeStyles } from '@material-ui/core';

const styles = makeStyles(theme => ({
    noticeContainer: {
        padding: '0 1.5rem',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
    notice: {
        paddingTop: '24px',
        paddingBottom: '40px',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '20px',
        },
    },
    text: {
        color: theme.palette.primary.heather,
        fontFamily: theme.typography.inputLabel.fontFamily,
        fontSize: theme.typography.inputLabel.fontSize,
        '& a': {
            textDecoration: 'underline !important',
        },
    },
}));

export default styles;
